import { useEffect, useState } from "react";
import {
  classNames,
  disabledIfFieldChecker,
  findChangedAndSimilarObjects,
  findDataInFields,
  findDataInObject,
} from "../../utils/helperFuctions";
import CardList from "../List/CardList";
import { extractDataOO } from "../../utils/helperFuctions";
import { useSelector } from "react-redux";
import { config } from "../../utils/config";
import axios from "axios";
import { getCookie, setCookie } from "../../utils/cookieHandler";

const RelatedCard = ({
  label,
  name,
  id,
  defaultValue,
  handleChange,
  handleInputChange,
  showAction,
  mainAction,
  rowActions,
  toShow,
  headerAction,
  inputField,
  subname,
  className,
  rowActionsShowNew,
  exclude,
  limit,
  addBarier,
  clearDataOnBranchChange,
  disabledIfField,
  disabledIfField2,
  disabled,
  removeItem,
  removeValueOnWhichFieldValueChange,
  calculateTotalAmount,
  lazyload,
  lazyloadParam,
  scroll,
  disableWhenDayEnds,
  onlyLatestCanBeDeleted,
  handleSubmit,
  callPopUp,
  useIndexAsKey,
  lockStatus,
  isLocked,
}) => {
  const currentFields = useSelector((state) => state.showFields);
  // console.log(toShow);

  // Create a wrapper for isLocked that maps field names to types
  const checkItemLocked = (item, fieldName) => {
    if (!isLocked || typeof isLocked !== 'function' || !item || !item.id) {
      return false;
    }
    
    // Map field names to billing event types
    const fieldTypeMap = {
      'charges': 'charge',
      'transactions': 'transaction',
      'reservation_addons': 'addon',
      'reservation_addons2': 'addon',
      'time_extension': 'timeAdjustment',
      'custom_orders': 'customOrder',
    };
    
    const lockType = fieldTypeMap[fieldName];
    if (!lockType) {
      return false;
    }
    
    return isLocked(lockType, item.id);
  };

  const [data, setData] = useState(() => {
    if (Array.isArray(exclude)) {
      return defaultValue
        ? Array.isArray(defaultValue)
          ? defaultValue.length > 0
            ? extractDataOO(
                exclude
                  ? defaultValue.filter((x) => {
                      let flag = true;
                      for (const ex of exclude) {
                        if (x[ex.name] !== ex.value) {
                          flag = false;
                          break;
                        }
                      }
                      return flag;
                    })
                  : defaultValue,
                toShow
              )
            : null
          : null
        : null;
    } else {
      return defaultValue
        ? Array.isArray(defaultValue)
          ? defaultValue.length > 0
            ? extractDataOO(
                exclude
                  ? defaultValue.filter((x) => {
                      return x[exclude.name] !== exclude.value;
                    })
                  : defaultValue,
                toShow
              )
            : null
          : null
        : null;
    }
  });

  const [valueLazyloaded, setValueLazyloaded] = useState({
    previousValue: null,
    changed: false,
  });

  const handleActionClick = (data, name, action) => {
    handleChange(data, name, action);
  };

  const handleheaderActionClick = (e) => {
    const _name = e.target.name;
    let concatData = {};
    if (headerAction.concatWith) {
      for (const prop_ in headerAction.concatWith) {
        if (headerAction.concatWith[prop_].includes("<s>")) {
          concatData[prop_] = headerAction.concatWith[prop_].replace("<s>", "");
        } else if (headerAction.concatWith[prop_].includes("<now>")) {
          concatData[prop_] = new Date().toISOString();
        } else {
          concatData[prop_] = findDataInFields(
            currentFields,
            headerAction.concatWith[prop_]
          );
        }
      }
    }

    handleChange(concatData, name, _name, subname);
  };
  const inputfieldChange = (e) => {};

  const getLazyload = async (
    url,
    lazyloadParam,
    toSend,
    diff,
    same,
    currentValues,
    flagField
  ) => {
    try {
      if (url) {
        setValueLazyloaded((prev) => ({ ...prev, changed: false }));
        axios
          .post(`${config.apiUrl}/api/${url}`, toSend, {
            headers: { Authorization: `Bearer ${getCookie("_AT")}` },
          })
          .then((d) => {
            //console.log(d)
            if (d.headers?.authorization) {
              if (`Bearer ${getCookie("_AT")}` !== d.headers.authorization) {
                setCookie("_AT", d.headers.authorization.split(" ")[1]);
              }
            }
            if (Array.isArray(d.data)) {
              let changed = [];
              if (d.data.length === diff.length) {
                d.data.forEach((e, index) => {
                  changed.push({
                    ...diff[index],
                    [inputField.changeParam || "unknown"]: e[lazyloadParam],
                    changed: false,
                  });
                });
              }
              if (changed.length > 0) {
                const upd = [...same, ...changed];
                setValueLazyloaded({
                  changed: false,
                  previousValue: {
                    ...currentValues,
                    [flagField || "unknown"]: upd,
                  },
                });
                handleInputChange({
                  target: {
                    name: subname ? subname : name,
                    value: upd,
                    related: true,
                  },
                });
              }
              return d.data;
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    } catch (e) {
      console.log(e);
    }
  };

  //setData(defaultValue ? (Array.isArray(defaultValue) ?  (defaultValue.length > 0 ? extractDataOO(defaultValue,toShow) : null) : null ) : null)
  useEffect(() => {
    setData(() => {
      if (Array.isArray(exclude)) {
        return defaultValue
          ? Array.isArray(defaultValue)
            ? defaultValue.length > 0
              ? extractDataOO(
                  exclude
                    ? defaultValue.filter((x) => {
                        let flag = true;
                        for (const ex of exclude) {
                          if (ex.name.includes(".")) {
                            const split = ex.name.split(".");
                            const compName1 = x[split[0]];
                            const compName2 = compName1
                              ? compName1[split[1]]
                              : "";
                            if (compName2) {
                              if (compName2 === ex.value) {
                                flag = false;
                                break;
                              }
                            } else {
                              continue;
                            }
                          } else {
                            if (x[ex.name] === ex.value) {
                              flag = false;
                              break;
                            }
                          }
                        }
                        return flag;
                      })
                    : defaultValue,
                  toShow
                )
              : null
            : null
          : null;
      } else {
        return defaultValue
          ? Array.isArray(defaultValue)
            ? defaultValue.length > 0
              ? extractDataOO(
                  exclude
                    ? defaultValue.filter((x) => {
                        return x[exclude.name] !== exclude.value;
                      })
                    : defaultValue,
                  toShow
                )
              : null
            : null
          : null;
      }
    });
  }, [defaultValue, exclude]);

  useEffect(() => {
    setValueLazyloaded((prev) => {
      return { ...prev, changed: true };
    });
  }, [currentFields]);

  useEffect(() => {
    if (valueLazyloaded.changed) {
      let changedObjects = [];
      let similarObjects = [];
      let flagField = "";
      if (Array.isArray(inputField?.lazyloadFieldChange) && currentFields) {
        let flag = false;
        let currentValues = valueLazyloaded.previousValue;
        for (const i in inputField.lazyloadFieldChange) {
          let f = inputField.lazyloadFieldChange[i];
          const findRelatedField = currentFields.find(
            (x) => x.name === f && x.changed === true
          );
          if (
            Array.isArray(findRelatedField?.defaultValue) &&
            (currentValues ? !Array.isArray(currentValues[f]) : true)
          ) {
            changedObjects = findRelatedField.defaultValue.filter(
              (x) => x.changed === true
            );
            similarObjects = findRelatedField.defaultValue.filter(
              (x) => x.changed !== true
            );
            flag = true;
            flagField = f;
            break;
          } else if (
            Array.isArray(findRelatedField?.defaultValue) &&
            (currentValues ? Array.isArray(currentValues[f]) : false) &&
            inputField.arrayFieldChangeCond
          ) {
            if (inputField.arrayFieldChangeCond[f]) {
              if (
                inputField.arrayFieldChangeCond[f].searchField &&
                inputField.arrayFieldChangeCond[f].changeField
              ) {
                const { _changedObjects, _similarObjects } =
                  findChangedAndSimilarObjects(
                    currentValues[f],
                    findRelatedField.defaultValue,
                    inputField.arrayFieldChangeCond[f].searchField,
                    inputField.arrayFieldChangeCond[f].changeField,
                    inputField.arrayFieldChangeCond[f].altSearchField
                  );
                changedObjects = _changedObjects;
                similarObjects = _similarObjects;

                if (changedObjects?.length > 0) {
                  //console.log('ccc: ',changedObjects)
                  flag = true;
                  flagField = f;
                  break;
                }
              }
            }
          } else if (findRelatedField?.defaultValue && currentValues) {
            const paraused = subname ? subname : name;
            if (!Array.isArray(currentValues[paraused])) {
              const thefield = currentFields.find((x) => x.name === paraused);
              if (Array.isArray(thefield?.defaultValue)) {
                changedObjects = [...thefield.defaultValue];
                similarObjects = [];
                flag = true;
                flagField = paraused;
                break;
              }
            }
          }
        }

        if (flag) {
          //setValueLazyloaded({ changed: false, previousValue: currentValues })
          if (
            inputField?.lazyloadUrl &&
            inputField?.lazyloadParam &&
            inputField?.body
          ) {
            const toSend = changedObjects.map((e) => {
              const _toSend = {};
              if (inputField.body.fromData) {
                for (const key in inputField.body.fromData) {
                  _toSend[key] = findDataInObject(
                    e,
                    inputField.body.fromData[key]
                  );
                }
              }
              if (inputField.body.fromFields) {
                for (const key in inputField.body.fromFields) {
                  if (currentFields) {
                    _toSend[key] = findDataInFields(
                      currentFields,
                      inputField.body.fromFields[key]
                    );
                  }
                }
              }

              return _toSend;
            });

            //console.log('toSendRelated: ',toSend)

            getLazyload(
              inputField.lazyloadUrl,
              inputField.lazyloadParam,
              toSend,
              changedObjects,
              similarObjects,
              currentValues,
              flagField
            );
          }
        }
      }
    }
  }, [valueLazyloaded]);

  const forceReloadInputFunction = async (e) => {
    let changedObjects = [];
    let similarObjects = [];
    let flag = false;
    let flagField = "";
    const paraused = subname ? subname : name;
    const thefield = currentFields.find((x) => x.name === paraused);
    let currentValues = valueLazyloaded.previousValue;

    if (thefield?.defaultValue && inputField?.arrayFieldChangeCond) {
      if (
        inputField.arrayFieldChangeCond[paraused]?.searchField &&
        inputField.arrayFieldChangeCond[paraused]?.changeField
      ) {
        if (e?.target?.dataset?.id) {
          if (!isNaN(parseInt(e.target.dataset.id))) {
            const searchID = parseInt(e.target.dataset.id);
            changedObjects = thefield.defaultValue.filter(
              (x) => x.id === searchID || x.tempid === searchID
            );
            similarObjects = thefield.defaultValue.filter(
              (x) => x.id !== searchID && x.tempid !== searchID
            );
            flagField = paraused;
            if (
              inputField?.lazyloadUrl &&
              inputField?.lazyloadParam &&
              inputField?.body
            ) {
              const toSend = changedObjects.map((e) => {
                const _toSend = {};
                if (inputField.body.fromData) {
                  for (const key in inputField.body.fromData) {
                    _toSend[key] = findDataInObject(
                      e,
                      inputField.body.fromData[key]
                    );
                  }
                }
                if (inputField.body.fromFields) {
                  for (const key in inputField.body.fromFields) {
                    if (currentFields) {
                      _toSend[key] = findDataInFields(
                        currentFields,
                        inputField.body.fromFields[key]
                      );
                    }
                  }
                }

                return _toSend;
              });

              //console.log('toSendRelated: ',toSend)

              const d = await getLazyload(
                inputField.lazyloadUrl,
                inputField.lazyloadParam,
                toSend,
                changedObjects,
                similarObjects,
                currentValues,
                flagField
              );

              return d;
            }
          }
        }
      }
    }
  };

  function sortObjectsById(array) {
    if (!Array.isArray(array)) {
      return [];
    }

    array.sort((a, b) => b.id - a.id);
    return array;
  }

  //start if check extras quantity is null dont show anything
  let quantity;
  if (data != null) {
    if (data[0] != null) {
      if (data[0].quantity != null) {
        quantity = 0;
      }
    }
    data.forEach((d) => {
      if (d.quantity != null) {
        quantity += parseInt(d.quantity);
      }
    });
  }
  if (quantity === 0) return null;
  // end

  const isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabledIfField2 != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField2.field,
          valuesArray: disabledIfField2.isEqual,
        })
      : disabled ?? false;
  const customSort = (items) => {
    if (!Array.isArray(items)) return [];

    return [...items].sort((a, b) => {
      const aIsNew = a.new === true;
      const bIsNew = b.new === true;

      if (aIsNew && !bIsNew) return -1;
      if (!aIsNew && bIsNew) return 1;

      if (aIsNew && bIsNew) {
        const aTime = new Date(a.createdOn).getTime();
        const bTime = new Date(b.createdOn).getTime();
        return bTime - aTime;
      }

      return b.id - a.id;
    });
  };
  // console.log(data, customSort(data), "asdasd");

  return (
    <div className={`bg-white rounded-lg shadow ${className}`}>
      <div className="border-b border-gray-200 bg-gray-100 px-4 py-5 sm:px-6 rounded-t-lg">
        <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
          <div className="ml-4 mt-2">
            <h3 className="text-base font-semibold leading-6 text-gray-700">
              {label}
            </h3>
          </div>
          <div className="ml-2 mt-2 flex-shrink-0">
            {(data?.length || 0) < (parseInt(limit) || 1000) && (
              <button
                disabled={isFieldDisabled}
                style={{
                  cursor: isFieldDisabled ? "not-allowed" : "pointer",
                  opacity: isFieldDisabled ? "15%" : "100%",
                }}
                type="button"
                onClick={handleheaderActionClick}
                name={headerAction?.id}
                className={classNames(
                  headerAction ? "" : "hidden",
                  "relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                )}
              >
                {headerAction?.name}
              </button>
            )}
          </div>
        </div>
      </div>

      <CardList
        useIndexAsKey={useIndexAsKey}
        handleSubmit={handleSubmit}
        callPopUp={callPopUp}
        onlyLatestCanBeDeleted={onlyLatestCanBeDeleted}
        id={id}
        scroll={scroll}
        setData={setData}
        lazyload={lazyload}
        lazyloadParam={lazyloadParam}
        calculateTotalAmount={calculateTotalAmount}
        removeValueOnWhichFieldValueChange={removeValueOnWhichFieldValueChange}
        isFieldDisabled={isFieldDisabled}
        mainAction={mainAction}
        rowActions={rowActions}
        data={
          // removeItem != null && data != null
          // ? customSort(
          //     data.filter(
          //       (item) =>
          //         !removeItem.some((remove) => item.title.includes(remove))
          //     )
          //   )
          // :
          customSort(data)
        }
        disableWhenDayEnds={disableWhenDayEnds}
        actionClicked={handleActionClick}
        name={subname ? subname : name}
        inputField={inputField}
        handleInputChange={handleInputChange}
        rowActionsShowNew={rowActionsShowNew}
        forceReloadFunction={forceReloadInputFunction}
        currentFields={currentFields}
        clearDataOnBranchChange={clearDataOnBranchChange}
        lockStatus={lockStatus}
        isLocked={checkItemLocked}
        fieldName={name}
      />
    </div>
  );
};

export default RelatedCard;
